import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import Img1 from "../../images/Screenshot 2024-06-29 183136.png";
import Img2 from "../../images/Screenshot 2024-06-29 184104.png";
import Img3 from "../../images/Screenshot 2024-06-29 184847.png";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

function Header() {
  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 50,
      smooth: "easeInOutQuint",
    });
  };

  return (
    <section
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Slider الخلفية بكامل الشاشة */}
      <Swiper
        loop={true}
        effect="fade"
        autoplay={{ delay: 3000 }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        modules={[EffectFade, Navigation, Autoplay]}
        style={{ width: "100%", height: "100%" }}
      >
        <SwiperSlide style={{ width: "100%", height: "100%" }}>
          <img
            src={Img1}
            alt="Image 1"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </SwiperSlide>
        <SwiperSlide style={{ width: "100%", height: "100%" }}>
          <img
            src={Img2}
            alt="Image 2"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </SwiperSlide>
        <SwiperSlide style={{ width: "100%", height: "100%" }}>
          <img
            src={Img3}
            alt="Image 3"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </SwiperSlide>
      </Swiper>

      {/* أزرار التنقل */}
      <button
        className="swiper-button-prev"
        style={{
          position: "absolute",
          top: "50%",
          left: "20px",
          zIndex: 20,
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          border: "none",
          color: "#fff",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
        }}
        aria-label="السابق"
      >
        &#10094;
      </button>
      <button
        className="swiper-button-next"
        style={{
          position: "absolute",
          top: "50%",
          right: "20px",
          zIndex: 20,
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.5)",
          border: "none",
          color: "#fff",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
        }}
        aria-label="التالي"
      >
        &#10095;
      </button>

      {/* المحتوى التراكبي */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.4)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10,
          color: "#fff",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        <h2 style={{ fontSize: "3rem", marginBottom: "20px", color: "white" }}>
          مرحبا بكم في روز باريس للعطور
        </h2>
        <p style={{ fontSize: "1.25rem", marginBottom: "30px" }}>
          اكتشفوا عالماً من الروائح الفريدة والأناقة الراقية مع تشكيلتنا
          المميزة.
        </p>
        <Link
          onClick={scrollToTop}
          to="/products"
          style={{
            padding: "10px 20px",
            fontSize: "1rem",
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "50px",
            textDecoration: "none",
          }}
        >
          تسوق الأن
        </Link>
      </div>
    </section>
  );
}

export default Header;
